<template>
  <div>
    <el-row>
      <el-col class="lang" :span="4" :offset="18">

        <span v-for="(item) in langList" :key="item.id">
          <!-- <span v-show="index != langList.length - 1"> | </span> -->
          <span :class="{ active: item.active }" style="margin: 0 3px;" @click="langChoose(item)">{{ item.title
            }}</span>
          <span> {{ item.spa }}</span>
        </span>
      </el-col>
    </el-row>
    <div class="login-content">
      <!-- <div class="login-logo">
				<img src="@/assets/dllogo.png" alt="">
			</div> -->
      <el-row>
        <el-col :offset="6" :span="12">
          <img src="@/assets/dllogo.png" alt="" />
          <!-- <img src="@/assets/fuyu.png" width="356" alt="" /> -->
        </el-col>
      </el-row>
      <div class="login-body">
        <el-row>
          <el-col :span="12">
            <div class="login-left">
              <img src="@/assets/bgleft.png" alt="" />
            </div>
          </el-col>
          <el-col :span="12">
            <div class="login-page" v-if="getloginForm">
              <el-form :model="userLoginForm" status-icon ref="userLoginFormRef" label-position="left" label-width="0px"
                class="demo-ruleForm login-page-right">
                <h3 class="title" :class="{ ischeck: tab_check }" style="cursor: pointer">
                  {{ $t("message.title.userLogin") }}
                </h3>
                <!-- <h3 class="title2" :class="{ischeck:!tab_check}" @click="tabCheck2" style="cursor: pointer;">其他登录</h3> -->

                <div class="table1 agreement" v-if="tab_check" style="float: left; width: 100%">
                  <el-form-item prop="tenantName" class="login-input">
                    <el-input type="text" v-model="userLoginForm.tenantName" auto-complete="off"
                      :placeholder="$t('message.placeholder.companyName')" prefix-icon="  el-icon-suitcase"></el-input>
                  </el-form-item>
                  <el-form-item prop="username" class="login-input">
                    <el-input type="text" v-model="userLoginForm.username" auto-complete="off"
                      :placeholder="$t('message.placeholder.userName')" prefix-icon="  el-icon-user"></el-input>
                  </el-form-item>
                  <el-form-item prop="password">
                    <el-input @keyup.enter.native="handleSubmit" type="password" v-model="userLoginForm.password"
                      auto-complete="off" :placeholder="$t('message.placeholder.PW')"
                      prefix-icon="el-icon-unlock"></el-input>
                  </el-form-item>
                  <div prop="type" style="margin-bottom: 20px;" v-if="isAgreement">
                    <template style="width:100%">
                      <el-checkbox v-model="approveChecked">
                        {{ $t("message.title.readAndAgree") }}
                      </el-checkbox>
                      <el-link type="primary" @click="privacy" style="margin-top: -3px;">《杰信云隐私政策》</el-link>，
                      <el-link type="primary" @click="terms"
                        style="margin-top: -3px;line-height: 20px;">《杰信云用户协议》</el-link>
                    </template>
                  </div>
                  <div></div>

                  <!-- <el-checkbox v-model="checked" class="rememberme" style="width: 50%;float: left;">记住密码</el-checkbox>
								<a href="javascript:void(0)" style="width: 50%;float: left;text-align: right;font-size: 14px;color: #409EFF;" @click="forgetPassword">忘记密码</a> -->
                  <el-form-item style="width: 100%; overflow: hidden">
                    <div style="float: right; width: 100%" class="login-submit">
                      <el-button type="primary" style="width: 100%" :class="{ clicked: isSubmitClick }"
                        @click="handleSubmit" :loading="loading">{{ $t("message.title.login") }}</el-button>
                    </div>
                  </el-form-item>
                </div>
                <div class="table2" v-if="!tab_check">
                  <img src="@/assets/weihu.jpg" alt="" />
                </div>
              </el-form>
            </div>
            <div v-else>
              <reset-pw />
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    <div class="bottom">
      <a href="https://beian.miit.gov.cn/" target="blank" class="copyright">{{
        $t("message.tips.Copyright")
      }}</a>
      <span> | </span>
      <span style="cursor: pointer;" @click="refresh">
        {{ $t("message.tips.ClearCache") }}
        <!-- 清空本地缓存 -->
      </span>
    </div>
  </div>
</template>


<script>
import axios from "axios";
import ResetPw from "./resetPW.vue";

export default {
  data() {
    return {
      //isShow: false,
      //dialogVisible: false,
      imgCode: undefined,
      //表单用户登入数据
      loading: false,
      tab_check: true,
      userLoginForm: {
        // tenantName: "试用租户",
        // username: "Sal",
        // password: "admin",
        tenantName: "",
        username: "",
        password: "",
      },

      langList: [
        { title: '中文', id: 'zh', active: false, spa: '|' },
        { title: 'English', id: 'en', active: false, spa: '|' },
        { title: '日本語', id: 'jp', active: false },
      ],

      isAgreement: false,

      isActive: Boolean,
      isSubmitClick: false,
      loginLang: "",
      approveChecked: false,

      note: {
        backgroundImage: "url(" + require("@/assets/bg3.png") + ")",
        "background-size": "cover",
        "background-repeat": "no-repeat",
        "background-position": "50% 50%",
      },

      checked: true,
      getloginForm: true

      //验证规则
      // loginRules: {
      //   tenantName: [
      //     {
      //       required: true,
      //       //message: this.$t("message.tips.companyName"),
      //       trigger: "blur",
      //     },
      //     // { message: "请输入公司名", trigger: "blur" },
      //   ],
      //   username: [
      //     {
      //       required: true,
      //       //message: this.$t("message.tips.userName"),
      //       trigger: "blur",
      //     },
      //     // {
      //     //   min: 3,
      //     //   max: 12,
      //     //   message: "长度在 3 到 12 个字符",
      //     //   trigger: "blur",
      //     // },
      //   ],
      //   password: [
      //     {
      //       required: true,
      //       //message: this.$t("message.tips.PW"),
      //       trigger: "blur",
      //     },
      //     // {
      //     //   min: 5,
      //     //   max: 15,
      //     //   message: "长度在 5 到 15 个字符",
      //     //   trigger: "blur",
      //     // },
      //   ],
      // },
    }
  },
  components: { ResetPw },

  methods: {
    refresh() {
      location.reload();
    },
    terms() {
      let { href } = this.$router.resolve({ path: "/terms" });
      window.open(href, '_blank');
    },
    privacy() {
      let { href } = this.$router.resolve({ path: "/privacy" });
      window.open(href, '_blank');
    },
    langChoose(item) {
      // this.isActive = !this.isActive;
      this.langList.forEach(element => {
        element.active = false
      });
      item.active = true
      this.$i18n.locale = item.id;
      localStorage.setItem("lang", item.id);
    },
    getLang() {
      const lang = window.localStorage.getItem("lang")
      const id = lang ?? 'zh';
      if (!lang) {
        localStorage.setItem("lang", id);
      }
      this.$i18n.locale = id;
      this.langList.find(i => i.id == id).active = true;
    },

    //登入提交
    handleSubmit() {
      if (this.approveChecked || !this.isAgreement) {
        this.isSubmitClick = true;
        this.success();
      } else {
        this.$message({
          message: this.$t("message.tips.terms"),
          type: 'warning'
        });
      }
    },
    //重置表单
    resetForm: function () {
      this.userLoginForm.username = "";
      this.userLoginForm.password = "";
      this.userLoginForm.tenantName = "";
    },
    //验证成功
    async success() {
      this.loading = true;
      const lang = window.localStorage.getItem('lang') || 'zh'
      axios.post("/pmdm/login", {
        name: this.userLoginForm.username.replace(/(^\s*)|(\s*$)/g, ""),//去除首尾空格
        password: this.userLoginForm.password,
        tenantName: this.userLoginForm.tenantName.replace(/(^\s*)|(\s*$)/g, ""),
        lang: lang,
      }).then((res) => {
        //console.log(res,res.data.object.userContext.loginId);
        document.title = "Welcome, " + res.data.object.userContext.loginId;
        this.isSubmitClick = false;
        if (res.data.code == 200) {


          //保存token
          const { token: swift_TOKEN, userContext, ...temp } = res.data.object;
          const obj = {
            ...temp,
            swift_TOKEN,
            tenantName: this.userLoginForm.tenantName,
            currentUserId: userContext.id,
            userContext: JSON.stringify(userContext)
          }
          for (const i in obj) {
            if (Object.hasOwnProperty.call(obj, i)) {
              const e = obj[i];
              sessionStorage.setItem(i, e)
            }
          }

          this.$store.commit("setIsSuperAdmin", userContext.superMan);
          this.setCookie("userName", this.userLoginForm.username.replace(/(^\s*)|(\s*$)/g, ""), 15);
          this.setCookie("tenantName", this.userLoginForm.tenantName.replace(/(^\s*)|(\s*$)/g, ""), 15);
          this.setCookie("approveChecked", "isture", 30);


          if (res.data.object.modPassWordCode == 200) {
            this.getUserInfo();
          }
          if (res.data.object.modPassWordCode == 201) {
            // this.getUserInfo();
            this.getloginForm = false
          }

        }
      }).catch(_ => {
        this.isSubmitClick = false;
      }).finally(_ => {
        this.loading = false;
      });


    },
    setCookie: function (cName, value, expiredays) {//设置cookie
      var exdate = new Date();
      exdate.setDate(exdate.getDate() + expiredays);
      document.cookie = cName + '=' + decodeURIComponent(value) +
        ((expiredays == null) ? '' : ';expires=' + exdate.toUTCString());
    },
    getCookie: function (key) {//获取cookie
      if (document.cookie.length > 0) {
        var start = document.cookie.indexOf(key + '=')
        if (start !== -1) {
          start = start + key.length + 1
          var end = document.cookie.indexOf(';', start)
          if (end === -1) end = document.cookie.length
          return unescape(document.cookie.substring(start, end))
        }
      }
      return ''
    },

    /**
      获取用户信息
     */
    async getUserInfo() {
      this.$message({
        // title: "登入成功",
        message: this.$t("message.title.welcome"),
        type: "success",
        showClose: true,
      });
      this.$router.push("/home");
    },
    checkBg: function (Num) {
      if (Num == 1) {
        this.$router.push("/login");
      } else if (Num == 2) {
        this.$router.push("/loginDemo1");
      } else {
        this.$router.push("/loginDemo2");
      }
    },
    forgetPassword: function () {
      this.$alert("请联系系统管理员修改密码!", "", {
        confirmButtonText: this.$t("message.button.affirm"),
        callback: (action) => { },
      });
    },

    getUserCookie: function () {
      // 在页面加载时从cookie获取登录信息
      let userName_ = this.getCookie("userName");
      let tenantName_ = this.getCookie("tenantName");
      let approveChecked_ = this.getCookie("approveChecked");
      if (userName_) {
        this.userLoginForm.tenantName = tenantName_;
        this.userLoginForm.username = userName_;
      };
      if (approveChecked_) {
        this.approveChecked = true;
      };
    },

    getInfo() {
      axios.get('/pmdm/prepare').then(res => {
        const { tenantAgreement, tenantName } = res.data.object;
        this.isAgreement = !!tenantAgreement
        if (!tenantAgreement && tenantName) {
          this.userLoginForm.tenantName = tenantName;
        }
      })
        .catch(function (error) {
          console.log(error);
        });
    }
  },
  created() {
    this.getLang();
    this.getUserCookie();
    this.getInfo();
  },

}
</script>


<style scoped>
.copyright {
  color: #000;
  text-decoration: none;
}

.active {
  color: #fff;
  /* padding: 1px 3px; */
  /* border: #0078d7 1px solid; */
  border-radius: 3px;
  width: 50px;
  height: 18px;
  background: #409eff;
  pointer-events: none;
}

.clicked {
  pointer-events: none;
}

.lang>span {
  padding: 1px 3px;
  margin-top: 6px;
  font-size: 14px;
  cursor: pointer;
}

.login-content {
  margin-top: 10px;
  width: 100%;
}

.login-logo {
  width: 100%;
  height: 97px;
}

.login-logo img {
  margin-left: 360px;
  position: absolute;
}

.login-input {
  margin-bottom: 30px;
}

.login-body {
  width: 100%;
  height: 620px;
  /* 底色 */

  background-color: #3ea4f9;
  /* chrome 10+, safari 5.1+ */
  background-image: -webkit-linear-gradient(-45deg, #3ea4f9, #4588f9, #5c7c99);
  /* firefox; multiple color stops */
  background-image: -moz-linear-gradient(-45deg, #3ea4f9, #4588f9, #5c7c99);
  /* ie10 */
  background-image: -ms-linear-gradient(-45deg, #3ea4f9 0%, #4588f9 100%);
  /* opera 11.1 */
  background-image: -o-linear-gradient(-45deg, #3ea4f9, #4588f9);
  /* 标准写法 */
  background-image: linear-gradient(-45deg, #3ea4f9, #4588f9);
}

.login-left {
  /* background-color: brown; */
  float: right;
  /* background-image: url('~@/assets/bgleft.png'); */
}

.login-right {
  background-color: bisque;
}

/*  */

ul {
  overflow: hidden;
}

ul li {
  float: left;
  margin-left: 5.3%;
}

.login-container {
  width: 100%;
  height: 100%;
}

#login {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  /* background-image:  url('../assets/background.jpg');
	background-size: cover;
	background-repeat: no-repeat;
	background-position: 50% 50%; */
}

.bottom {
  width: 100%;
  text-align: center;
  /* margin-top: 70px; */
  font-size: 12px;
  position: fixed;
  bottom: 10px;
}

.check-bg {
  float: right;
  position: absolute;
  top: 10px;
  right: 20px;
}

.check-bg-1 {
  width: 120px;
  height: 80px;
  float: right;
  overflow: hidden;
  margin-right: 40px;
  border: 2px solid #cecece;
}

.check-bg-1:hover {
  border: 2px solid blue;
}

.check-bg-1 img {
  width: 100%;
  height: 100%;
}

.check-bg-2 {
  width: 120px;
  height: 80px;
  float: right;
  overflow: hidden;
  margin-right: 20px;
  border: 2px solid #cecece;
}

.check-bg-2:hover {
  border: 2px solid blue;
}

.check-bg-2 img {
  width: 100%;
  height: 100%;
}

.check-bg-3 {
  width: 120px;
  height: 80px;
  float: right;
  overflow: hidden;
  margin-right: 20px;
  border: 2px solid #cecece;
}

.check-bg-3:hover {
  border: 2px solid blue;
}

.check-bg-3 img {
  width: 100%;
  height: 100%;
}

.login-page {
  float: left;
  margin-left: 20px;
  width: 400px;
  height: 450px;
  margin-top: 80px;
  background: #fff;
  overflow: hidden;
  -webkit-border-radius: 10px;
  border-radius: 10px;
}

.swift-logo {
  width: 230px;
  margin-left: 30px;
  margin-top: 10px;
  overflow: hidden;
}

.swift-logo img {
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.login-page-right {
  position: relative;
  padding: 20px 40px 15px;
  background: #fff;
  overflow: hidden;
}

label.el-checkbox.rememberme {
  margin: 0px 0px 15px;
  text-align: left;
}

.login-submit {
  margin-bottom: 40px;
}

.title {
  width: auto;
  float: left;
  font-size: 18px;
  font-weight: 400;
  text-align: center;
  margin: 20px 0;
  padding: 5px 0;
}

.title2 {
  width: 33%;
  float: left;
  font-size: 18px;
  font-weight: 400;
  text-align: center;
  color: #000;
  margin: 30px 0;
  padding: 5px 0;
}

.ischeck {
  color: #0078d7;
  border-bottom: 3px solid #0078d7;
  height: 30px;
  line-height: 30px;
}

.table2 {
  width: 100%;
  float: left;
  overflow: hidden;
}

.table2 img {
  width: 100%;
}
</style>
